require('./add-record-template.html');
require('./add-number-final-template.html');
require('./number-config-template.html');
require('./max-lines-reached-template.html');
require('./sms-verify-number-modal-template.html');
require('./upgrade-212-modal-template.html');
require('./number-voiceover-template.html');
require('./tollfree-number-template.html');
require('./view-as-template.html');
require('./screenshare-install-chrome-ext-modal-template.html');
require('./screenshare-not-supported-modal-template.html');
require('./broadcast-sms-template.html');
require('./connected-lines-template.html');
require('./cancel-billing-template.html');
require('./screenshare-ended-modal-template.html');
require('./snooze-notif-modal-template.html');
require('./delete-line-template.html');
require('./connected-lines-template-styles.less');
require('./import-pin-list-template.html');
require('./popup-alert-template.html');

angular.module('bbl.modals', [])
  .factory('modals', ['$templateCache', '$compile', '$rootScope', ModalsFactory]);

function ModalsFactory($templateCache, $compile, $rootScope) {
  var cached = {};

  function showModal(url, scope) {
    if(cached[url]) {
      cached[url].remove();
    }

    var template = $templateCache.get(url),
      modal = attachModalElement(template, scope);

    cached[url] = $(modal);
    return cached[url];
  }

  function attachModalElement(html, scope) {
    element = angular.element(html);
    $compile(element)(scope || $rootScope.$new());
    angular.element('body').append(element);
    return element;
  }

  return {
    show: showModal.bind(0),

    addNewLine: showModal.bind(0, 'add-record-template.html'),
    maxLines: showModal.bind(0, 'max-lines-reached-template.html'),
    smsVerify: showModal.bind(0, 'sms-verify-number-modal-template.html'),
    upgr212: showModal.bind(0, 'upgrade-212-modal-template.html'),
    tollFree: showModal.bind(0, 'tollfree-number-template.html'),
    configNumber: showModal.bind(0, 'number-config-template.html'),
    voiceover: showModal.bind(0, 'number-voiceover-template.html'),
    numberAdded: showModal.bind(0, 'add-number-final-template.html'),

    viewAs: showModal.bind(0, 'view-as-template.html'),
    ssChromeExt: showModal.bind(0, 'screenshare-install-chrome-ext-modal-template.html'),
    ssNotSupported: showModal.bind(0, 'screenshare-not-supported-modal-template.html'),
    broadcastSms: showModal.bind(0, 'broadcast-sms-template.html'),
    cancelBilling: showModal.bind(0, 'cancel-billing-template.html'),
    screenshareEnded: showModal.bind(0, 'screenshare-ended-modal-template.html'),
    snoozeNotifications: showModal.bind(0, 'snooze-notif-modal-template.html'),
    importPinList: showModal.bind(0, 'import-pin-list-template.html'),
    popupAlert: showModal.bind(0, 'popup-alert-template.html'),
  };
}

require('./snooze-notif-modal-controller.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/modals/index.js
 ** module id = 129
 ** module chunks = 0
 **/